import { CESIUM_INPUT_EVENT_MAP } from 'app/map/services/map_input_handling/MapInputHandlerService';

export type IMapInputHandler = {
    [x in keyof typeof CESIUM_INPUT_EVENT_MAP]?: (event, modifier?) => void;
} & {
    cleanUp: () => void;
    name: string;
    active: boolean;
    isDefault: boolean;
};

export abstract class AbstractMapInputHandler {
    private _active: boolean;
    private _isDefault: boolean;
    private _name: string;

    protected constructor() {
        this._active = false;
        this._isDefault = false;
        this._name = this.constructor.name;
    }

    public get active(): boolean {
        return this._active;
    }

    public set active(active: boolean) {
        this._active = active;
    }

    public get isDefault(): boolean {
        return this._isDefault;
    }

    public set isDefault(isDefault: boolean) {
        this._isDefault = isDefault;
    }

    public get name(): string {
        return this._name;
    }

    public set name(name: string) {
        this._name = name;
    }
}

export class GenericHandler extends AbstractMapInputHandler implements IMapInputHandler {
    constructor() {
        super();
    }

    leftDown(event) {}
    leftUp(event) {}
    leftClick(event) {}
    rightClick(event) {}
    mouseMove(event) {}
    leftDoubleClick(event, modifier) {}
    cleanUp() {}
}

export const ZONE_TOUR_HANDLER = 'ZoneTourHandler';
